<kodit-page [showCardBlock]="showCardBlock">
    <kodit-table
      [tableConfig]="tableConfig"
      [items]="memorandumTableDtoList"
      [isTableLoading]="isLoading"
    ></kodit-table>
  </kodit-page>
  